import { Progress as P } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
export function Progress({ value = 0, className, ...props }: ComponentProps<typeof P.Root>) {
  return (
    <P.Root {...props} value={value} className={cn("cyra-progress", className)}>
      <P.Indicator
        style={{ transform: `translateX(-${100 - Math.max(0, Math.min(100, value ?? 0))}%)` }}
      />
    </P.Root>
  );
}
